function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useDrag } from "@use-gesture/react";
import styled, { css } from "styled-components";
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import map from "astrid-helpers/src/map";
import msToTime from "astrid-helpers/src/msToTime";
import useTemp from "astrid-hooks/src/useTemp";
import { Label, StyledCursor } from "./Cursor";
import { setCursor } from "./state/cursor";
import { getRect } from "./state/rect";
import { getShouldRipple, useRipple } from "./state/ripple";
import { useScope } from "./state/scope";
import { getSize } from "./state/size";
const StyledLabel = /*#__PURE__*/styled(Label).withConfig({
  displayName: "StyledLabel",
  componentId: "sc-11cz1ea-0"
})(["", " ", ""], ({
  moveable,
  active
}) => moveable && active && css(["cursor:grab;&:active{cursor:grabbing;}"]), ({
  active
}) => active && css(["top:-2px;border-color:currentColor;border-top:2px solid currentColor;"]));
const Marker = /*#__PURE__*/memo(({
  color,
  active,
  position,
  children,
  onMove,
  onClick,
  onChange
}) => {
  const ripple = useRipple();
  const {
    start,
    length
  } = useScope();
  const startPosition = useRef(0);
  const [timestamp, setTimestamp] = useState(false);
  const [tempPosition, setTempPosition] = useTemp(position);
  const left = useMemo(() => `${Math.max(0, (tempPosition - start) / length) * 100}%`, [length, tempPosition, start]);
  const onDrag = useDrag(useCallback(({
    tap,
    last,
    first,
    event,
    movement
  }) => {
    event.stopPropagation();
    if (first) {
      startPosition.current = position;
      setCursor(false);
    } else if (tap || last) {
      setCursor(true);
      setTimestamp(false);
      if (tap) {
        onClick && onClick();
      } else {
        onChange && onChange();
      }
    } else if (active) {
      const [x, y] = movement;
      const size = getSize();
      const {
        top,
        width
      } = getRect();
      const delta = map(x, 0, width, 0, size);
      const nextPosition = startPosition.current + delta;
      setTimestamp(y > top);
      onMove?.(nextPosition);
    }
  }, [active, onChange, onClick, onMove, position]));
  useEffect(() => {
    if (ripple && getShouldRipple()) {
      if (ripple[0] === false && position > ripple[1][0] || ripple[0] === true && position > ripple[1][0] && position < ripple[1][1]) {
        setTempPosition(position + ripple[2]);
      } else {
        setTempPosition(position);
      }
    }
  }, [position, ripple, setTempPosition]);
  return /*#__PURE__*/React.createElement(StyledCursor, _extends({
    left: left,
    color: color
  }, onDrag()), /*#__PURE__*/React.createElement(StyledLabel, {
    color: color,
    moveable: onMove,
    active: active
  }, timestamp ? msToTime(tempPosition) : children));
});
export default Marker;
//# sourceMappingURL=Marker.js.map